var inquiryCode='';
var familyCode='';
var promoCode='';

Vendd.Scripts.load( function()
{
    var baseUrl = $('.configurator-base-url').data('baseurl');
    var configuratorSourceUrl = $('.configurator-base-url').data('configuratorsourceurl');
    var $form=$( '.x-interest-form' ),
        $submitButton,form,formData;
    var $formConfigurator=$( '.x-interest-form-configurator' ),
        $submitButtonConfigurator,formConfigurator,formConfiguratorData;

    if( $form.length<1 )
        return;

    var submitClicked = false;

    $submitButton=$( '.js-submit-button',$form );
    $submitButtonConfigurator=$( '.js-submit-button',$formConfigurator );

    form=$form.get( 0 );
    formConfigurator=$formConfigurator.get( 0 );

    importEmailForRegistration();

    formData={
        "productCode": "",
        "firstName": "",
        "lastName": "",
        "phone": "",
        "email": "",
        "brand": "",
        "model": "",
        "area": "",
        "message": "",
        "offerName": "",
        "offerId": ""
        // "policyEmail": true,
        // "policyPhone": true,
        // "policySms": true
    };

    formConfiguratorData={
        "firstName": "",
        "lastName": "",
        "phone": "",
        "email": ""
    };


    form.resetDropdowns = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var element = $('select[name="area"]', $form);

            element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
            element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

            element = $('select[name="brand"]', $form);
            element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
            element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

            element = $('select[name="model"]', $form);
            element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
            element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

            var recreateSelect = "<select class=\"makesDropdown\" name=\"brand\" id=\"makesDropdown\" disabled> </select>";
            $('.makesDropdownDiv', $form).html(recreateSelect);
            $('.makesDropdown').sSelect();

            recreateSelect = "<select class=\"modelsDropdown\" name=\"model\" id=\"modelsDropdown\" disabled> </select>";
            $('.modelsDropdownDiv', $form).html(recreateSelect);
            $('.modelsDropdown').sSelect();

            var branch = $(".branchesDropdown", $form);
            branch.val("");
            branch.change();

            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        }
    };

    form.validateBranch = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var branchValue = formData.area;

            var element = $('select[name="area"]', $form);

            if (branchValue !== "" && branchValue !== null && branchValue !== undefined) {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

                return true;
            }
            else {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').addClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').addClass("error");

                return false;
            }
        }
    };

    form.updateBranch = function (branchValue) {
        if ($("#apiCallSuccessful").val() === "success") {
            //$('input[name="brand"]', $form).val(brandText);
            formData.area = branchValue;
            if (submitClicked)
                form.validateBranch();
        }
    };

    form.updateBranchText = function (branchTextValue) {
        formData.areaText = branchTextValue;
    };

    form.validateBrand = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var brandValue = formData.brand;

            var element = $('select[name="brand"]', $form);

            if (brandValue !== "" && brandValue !== null && brandValue !== undefined) {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

                return true;
            }
            else {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').addClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').addClass("error");

                return false;
            }
        }
    };

    form.updateBrand = function (brandValue) {
        if ($("#apiCallSuccessful").val() === "success") {
            //$('input[name="brand"]', $form).val(brandText);
            formData.brand = brandValue;
            if (submitClicked)
                form.validateBrand();
        }else {
            $('input[name="brand"]', $form).val(brandValue);
        }
    };

    form.updateBrandText = function (brandTextValue) {
        formData.brandText = brandTextValue;
    };

    form.validateModel = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var modelValue = formData.model;

            var element = $('select[name="model"]', $form);

            if (modelValue !== "" && modelValue !== null && modelValue !== undefined) {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

                return true;
            }
            else {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').addClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').addClass("error");

                return false;
            }
        }
    };

    form.updateModel = function (modelValue) {
        if ($("#apiCallSuccessful").val() === "success") {
            //$('input[name="brand"]', $form).val(brandText);
            formData.model = modelValue;
            if (submitClicked)
                form.validateModel();
        }else {
            $('input[name="model"]', $form).val(modelValue);
        }
    };

    form.updateModelText = function (modelTextValue) {
        formData.modelText = modelTextValue;
    };

    form.updateType = function (formType, formExternalService) {
        formData.type = formType;
        //Switch to external service for notification sending
        form.updateExternalService(formExternalService);
    };

    form.updateExternalService = function (formExternalService) {
        //Switch to external service for notification sending
        if (formExternalService == 'true')
            formData.externalService = 1;
        else
            formData.externalService = 0;
    };

    form.updateExternalLink = function (externalLink) {
        if (externalLink !== undefined && externalLink != '') {
            $('.external-link a', $form).attr('href', externalLink).html(externalLink);
            $('.external-link', $form).show();
        }
    };

    form.updateProductCode = function (code) {
        formData.productCode = code;
    };

    form.loading=function( loading )
    {
        if( loading )
        {
            $form.addClass( 'x-loading' );
        } else
        {
            $form.removeClass( 'x-loading' );
        }
    };

    formConfigurator.loading=function( loading )
    {
        if( loading )
        {
            $formConfigurator.addClass( 'x-loading' );
        } else
        {
            $formConfigurator.removeClass( 'x-loading' );
        }
    };

    form.onSuccess=function( envelope )
    {
        if( !$form.hasClass( 'x-loading' ) )
            return;

        form.loading( false );

        var notificationSent;

        if( formData.externalService )
        {
            notificationSent=1;
        } else
        {
            notificationSent=envelope.message.data.MailSent;
        }

        if( notificationSent )
        {
            $( '.js-error',$form ).hide();
            $( '.js-content',$form ).hide();
            $( '.js-success',$form ).show();
        }

        if( $( window ).width()<480 )
        {
            var toScroll=$( '.form-title-container',$form ).offset().top-20;
            $( '.fancybox-inner' ).animate( {scrollTop: toScroll},100,'swing' );
        }

        window.dataLayer.push({
            event: 'form_submit_success'
        }); 
    };

    //If there is a new model chosen through configurator
    formConfigurator.onSuccess=function()
    {
        if( !$formConfigurator.hasClass( 'x-loading' ) )
            return;

        formConfigurator.loading( false );

        $( '.js-error',$formConfigurator ).hide();
        $( '.js-content',$formConfigurator ).hide();
        $( '.js-success',$formConfigurator ).show();
        //Reset inquiryCode from configurator
        inquiryCode='';
        familyCode='';
        promoCode='';
        $( '.request-a-quote' ).attr( 'href','#interestForm' );

        if( $( window ).width()<480 )
        {
            var toScroll=$( '.form-title-container',$formConfigurator ).offset().top-20;
            $( '.fancybox-inner' ).animate( {
                scrollTop: toScroll
            },100,'swing' );
        }
    };

    form.onFailure=function( envelope )
    {

        form.loading( false );
        var $errorElem=$( '.js-error',$form );

        $errorElem.show();

        if( $( window ).width()<480 )
        {
            var toScroll=$errorElem.offset().top-20;
            $( '.fancybox-inner' ).animate( {scrollTop: toScroll},100,'swing' );
        }
    };

    formConfigurator.onFailure=function( envelope )
    {

        formConfigurator.loading( false );
        var $errorElem=$( '.js-error',$formConfigurator );

        $errorElem.show();

        if( $( window ).width()<480 )
        {
            var toScroll=$errorElem.offset().top-20;
            $( '.fancybox-inner' ).animate( {
                scrollTop: toScroll
            },100,'swing' );
        }
    };

    form.submit=function()
    {
        form.loading( true );

        form.trackEvent(formData);

        if( formData.externalService )
        {
            //form.sendNotificationExtService();
            form.CreateLead();
        } else
        {
            form.sendNotification();
        }
    };

    formConfigurator.submit=function()
    {
        formConfigurator.loading( true );
        if( promoCode!==''&&promoCode!==undefined )
        {
            // formConfigurator.getPromoToken();
            formConfigurator.sendPromoNotification();
        }
        if( inquiryCode!==''&&inquiryCode!==undefined )
        {
            formConfigurator.sendConfiguratorNotification();
        }
    };

    form.trackEvent = function (data) {
        var eventCategory = 'RequestQuoteForm';

        if (window.ga && ga.create) {
            if (eventCategory !== '') {
                ga('send', {
                    hitType: 'event',
                    eventCategory: eventCategory,
                    eventAction: 'Submit',
                    dimension1: data.brand,
                    dimension2: data.model
                });
            }
        }
    };

    form.CreateLead = function () {
        Vendd.MessageBus.publishAsync('CreateLead', new Vendd.SubmitToExternalEndpoint.Messages.CreateLead(formData));
    };

    form.sendNotificationExtService=function()
    {
        console.log( 'Switched to alternative method for form sending, setup the method and then remove the log' );
        var notificationTypeCode,recieverEmail,language;

        recieverEmail=$form.attr( 'data-email-reciever' );
        language=$form.attr( 'data-lang-code' );

        if( formData.type==='testDrive' )
        {
            notificationTypeCode='Custom-Form-Test-Drive';
        } else if( formData.type==='bookService' )
        {
            notificationTypeCode='Custom-Form-Service';
        }

        var params={
            FirstName: formData.firstName,
            LastName: formData.lastName,
            Phone: formData.phone,
            Email: formData.email,
            Brand: formData.brand,
            Model: formData.model,
            Area: formData.area,
            Date: formData.date,
            Message: formData.message
            // PolicyEmail: formData.policyEmail,
            // PolicyPhone: formData.policyPhone,
            // PolicySMS: formData.policySms,
        };

        var model={
            toemail: ( LhApp.IsDevEnvironment )? recieverEmail:formData.email,
            fromemail: formData.email,
            relatedObjectid: 10,
            langCode: language? language:'el',
            notificationTemplateCode: notificationTypeCode,
            param: params
        };

        $.ajax( {
            type: "POST",
            url: '',
            cache: false,
            dataType: 'json',
            data: {},
            statusCode: {
                200: function( response )
                {
                    form.onSuccess();
                },
                404: function( response )
                {
                    form.onFailure();
                },
                500: function( response )
                {
                    form.onFailure();
                }
            }
        } );
    };

    formConfigurator.sendPromoNotification=function( token )
    {
        var language=$formConfigurator.attr( 'data-lang-code' );
        $.ajax( {
            type: "POST",
            url: baseUrl + '/External/CreateLeadAndWorkflowForPackageRequestLHCampaing',
            cache: false,
            dataType: 'json',
            data: {
                "ModelTitle": null,
                "MakeName": "Other",
                "MakeCode": "Other",
                "ModelCode": null,
                "FamilyCode": null,
                "Mileage": null,
                "Year": null,
                "SelectedSalesPerson": null,
                "TransportationCode": null,
                "IsFromWebSite": true,
                "Confirmed": false,
                "Person": {
                    "Name": formConfiguratorData.firstName,
                    "LastName": formConfiguratorData.lastName,
                    "Email": formConfiguratorData.email,
                    "Phone": null,
                    "WorkPhone": null,
                    "MobilePhone": formConfiguratorData.phone,
                    "LicensePlate": "",
                    "VIN": null,
                    "Comment": promoCode,
                    "FullName": formConfiguratorData.firstName+' '+formConfiguratorData.lastName,
                    "EmailReply": false,
                    "TextMessageReply": false,
                    "CompanyName": null,
                    "Vat": null
                },
                "PackageViews": [],
                "VatPriceSum": 0.0,
                "PriceIncludingVATSum": 0.0,
                "SelectedPackagesCodes": [],
                "ServiceCode": 0,
                "SelectedPackagesAsString": "",
                "ServiceAmount": 0,
                "PayMethod": null,
                "PaymentReference": null,
                "PackagesDuration": 0.0,
                "Paid": false,
                "IsValid": false,
                "PackageIsOther": true,
                "Resource": "8",
                "CarCode": null,
                "CardCode": null,
                "ContactPersonCode": null,
                "DeliveryDate": null,
                "PickupDate": null,
                "SiteLang": language? language:'en',
                "Payment_Comments": null
            },
            statusCode: {
                200: function( response )
                {
                    formConfigurator.onSuccess();
                },
                404: function( response )
                {
                    formConfigurator.onFailure();
                },
                500: function( response )
                {
                    formConfigurator.onFailure();
                }
            }
        } );
    };

    formConfigurator.sendConfiguratorNotification=function()
    {
        var language=$formConfigurator.attr( 'data-lang-code' );
        $.ajax( {
            type: "POST",
            url: baseUrl + '/SalesOpportunity/CreateLeadFromConfigurator',
            cache: false,
            dataType: 'json',
            data: {
                inquiryCode: inquiryCode,
                firstName: formConfiguratorData.firstName,
                lastName: formConfiguratorData.lastName,
                email: formConfiguratorData.email,
                phone1: formConfiguratorData.phone,
                phone2: '',
                language: language? language.toUpperCase():'EN',
                makeCode: familyCode
            },
            statusCode: {
                200: function( response )
                {
                    formConfigurator.onSuccess();
                },
                404: function( response )
                {
                    formConfigurator.onFailure();
                },
                500: function( response )
                {
                    formConfigurator.onFailure();
                }
            }
        } );
    };

    form.sendNotification=function()
    {

        var recieverEmail=$form.attr( 'data-email-reciever' );
        var language=$form.attr( 'data-lang-code' );

        var params={
            ProductCode: formData.productCode,
            FirstName: formData.firstName,
            LastName: formData.lastName,
            Phone: formData.phone,
            Email: formData.email,
            Brand: formData.brand,
            Model: formData.model,
            Area: formData.area,
            Message: formData.message,
            OfferName: formData.offerName,
            OfferId: formData.offerId
            // PolicyEmail: formData.policyEmail,
            // PolicyPhone: formData.policyPhone,
            // PolicySMS: formData.policySms,
        };

        var model={
            toemail: ( LhApp.IsDevEnvironment )? recieverEmail:formData.email,
            fromemail: formData.email,
            relatedObjectid: 10,
            langCode: language? language:'el',
            notificationTemplateCode: 'Custom-Form-Quote-Request',
            param: params
        };

        Vendd.MessageBus.publishAsync( 'CustomForm',new Vendd.CustomForms.Messages.SendNotification( model ) );

    };

    form.reset=function()
    {
        submitClicked = false;

        $( '.js-error',$form ).hide();
        $( '.js-exists',$form ).hide();
        $( '.js-success',$form ).hide();
        $( '.js-content',$form ).show();
        $('.external-link', $form).hide();

        $( 'input[name="firstName"]',$form ).val( "" ).parent().removeClass( 'error' );
        $( 'input[name="lastName"]',$form ).val( "" ).parent().removeClass( 'error' );
        $( 'input[name="phone"]',$form ).val( "" ).parent().removeClass( 'error' );
        $( 'input[name="email"]',$form ).val( "" ).parent().removeClass( 'error' );
        //$( 'input[name="brand"]',$form ).val( "" ).prop( "disabled",false ).parent().removeClass( 'error disabled' );
        //$( 'input[name="model"]',$form ).val( "" ).prop( "disabled",false ).parent().removeClass( 'error disabled' );
        //$( 'input[name="area"]',$form ).val( "" ).prop( "disabled",false ).parent().removeClass( 'error disabled' );
        $('select[name="serviceType"]', $form).val("_").parent().removeClass('selected');
        //$('select[name="area"]', $form).val("_").parent().removeClass('selected');
        $( 'textarea[name="message"]',$form ).val( "" );
        $( '#email' ).prop( 'checked',true );
        $( '#phone' ).prop( 'checked',true );
        $( '#sms' ).prop( 'checked',true );

        form.unsetOfferName();

        if ($("#apiCallSuccessful").val() === "success") {
            formData = {
                "productCode": "",
                "firstName": "",
                "lastName": "",
                "phone": "",
                "email": "",
                //"brand": "",
                //"model": "",
                //"area": "",
                "message": "",
                "brandText": "",
                "modelText": "",
                "areaText": "",
                // "policyEmail": true,
                // "policyPhone": true,
                // "policySms": true,
            };
        }
        else {
            formData = {
                "productCode": "",
                "firstName": "",
                "lastName": "",
                "phone": "",
                "email": "",
                "brand": "",
                "model": "",
                "area": "",
                "message": "",
                "brandText": "",
                "modelText": "",
                "areaText": "",
                // "policyEmail": true,
                // "policyPhone": true,
                // "policySms": true,
            };

            $('input[name="brand"]', $form).val("");
            $('input[name="model"]', $form).val("");
            $('select[name="area"]', $form).val("");
            $('select[name="area"]', $form).change();
        }

        rf.reset();
        if ($("#apiCallSuccessful").val() === "success") {
            form.resetDropdowns();
        }
        else {
            $('input[name="firstName"]', $form).val("").parent().removeClass('error');
            $('input[name="lastName"]', $form).val("").parent().removeClass('error');
            $('input[name="phone"]', $form).val("").parent().removeClass('error');
            $('input[name="email"]', $form).val("").parent().removeClass('error');
            $('input[name="brand"]', $form).val("");
            $('input[name="model"]', $form).val("");
            $('select[name="area"]', $form).val("");
            $('select[name="area"]', $form).change();
        }
    };

    formConfigurator.reset=function()
    {
        $( '.js-error',$formConfigurator ).hide();
        $( '.js-exists',$formConfigurator ).hide();
        $( '.js-success',$formConfigurator ).hide();
        $( '.js-content',$formConfigurator ).show();

        $( 'input[name="firstName"]',$formConfigurator ).val( "" ).parent().removeClass( 'error' );
        $( 'input[name="lastName"]',$formConfigurator ).val( "" ).parent().removeClass( 'error' );
        $( 'input[name="phone"]',$formConfigurator ).val( "" ).parent().removeClass( 'error' );
        $( 'input[name="email"]',$formConfigurator ).val( "" ).parent().removeClass( 'error' );

        formConfiguratorData={
            "firstName": "",
            "lastName": "",
            "phone": "",
            "email": ""
        };

        rfc.reset();
    };

    form.handleErrors = function () {
        var $errorWrappers = $('.validator', $form);
        var emailError = false;
        $.each($errorWrappers, function (i, wrapper) {

            var $this = $(wrapper);
            if ($this.hasClass('error')) {
                if ($this.hasClass('email-required') || $this.hasClass('email-invalid')) {
                    if (!emailError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').addClass('error');
                        emailError = true;
                    }
                } else {
                    $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').addClass('error');
                }

            } else {
                if ($this.hasClass('email-required') || $this.hasClass('email-invalid')) {
                    if (!emailError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').removeClass('error');
                    }
                } else {
                    $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').removeClass('error');
                }

            }
        });

        if ($(window).width() < 480) {
            var errorElem = $('.error:first', $form);
            if (errorElem.length > 0) {
                setTimeout(function () {
                    var toScroll = $('.error:first', $form).offset().top - 30;
                    $('html, body').animate({ scrollTop: toScroll }, 100, 'swing');
                }, 1500);

            }

        }
    };
    
    form.setOfferName = function (offer, code,) {
        $('.offer-title .value', $form).text(offer);
        $('.offer-code .value', $form).text(code);
        formData.offerId = code;
        formData.offerName = offer;
    };

    form.unsetOfferName = function () {
        $('.offer-title .value', $form).text('');
        $('.offer-code .value', $form).text('');
        formData.offerId = null;
        formData.offerName = null;
    };

    formConfigurator.handleErrors=function()
    {
        var $errorWrappers=$( '.validator',$formConfigurator );
        var emailError=false;
        $.each( $errorWrappers,function( i,wrapper )
        {

            var $this=$( wrapper );
            if( $this.hasClass( 'error' ) )
            {
                if( $this.hasClass( 'email-required' )||$this.hasClass( 'email-invalid' ) )
                {
                    if( !emailError )
                    {
                        $this.closest( '.form-row' ).children( '.input-wrapper' ).addClass( 'error' );
                        emailError=true;
                    }
                } else
                {
                    $this.closest( '.form-row' ).children( '.input-wrapper' ).addClass( 'error' );
                }

            } else
            {
                if( $this.hasClass( 'email-required' )||$this.hasClass( 'email-invalid' ) )
                {
                    if( !emailError )
                    {
                        $this.closest( '.form-row' ).children( '.input-wrapper' ).removeClass( 'error' );
                    }
                } else
                {
                    $this.closest( '.form-row' ).children( '.input-wrapper' ).removeClass( 'error' );
                }

            }
        } );

        if( $( window ).width()<480 )
        {
            var errorElem=$( '.error:first',$formConfigurator );
            if( errorElem.length>0 )
            {
                setTimeout( function()
                {
                    var toScroll=$( '.error:first',$formConfigurator ).offset().top-30;
                    $( 'html, body' ).animate( {
                        scrollTop: toScroll
                    },100,'swing' );
                },1500 );
            }
        }
    };
    var valOpts={
        firstName: {
            required: 'firstname-required'
        },
        lastName: {
            required: 'lastname-required'
        },
        phone: {
            required: 'phone-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        }
    };

    $("#apiCallSuccessful").change(function () {

        if ($("#apiCallSuccessful").val() === "success") {

            rf.removeField("area");
            rf.removeField("brand");
            rf.removeField("model");

            $('#serviceType', $form).sSelect().change(function () {
                var $this = $(this);
                var fieldName = $this.attr('name');
                if ($this.val() !== '') {
                    formData[fieldName] = $this.val();
                    $this.parent().addClass('selected');
                }

                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                form.handleErrors($('.validator', $(this).parents('.form-row')));
            });
        }
        else {
            valOpts['area'] = {
                required: 'area-required'
            };
            valOpts['model'] = {
                required: 'model-required'
            };
            valOpts['brand'] = {
                required: 'brand-required'
            };
            $('select', $form).sSelect().change(function () {
                var $this = $(this);
                var fieldName = $this.attr('name');
                if ($this.val() !== '') {
                    formData[fieldName] = $this.val();
                    $this.parent().addClass('selected');
                }

                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                form.handleErrors($('.validator', $(this).parents('.form-row')));
            });
        }
    });

    var valOptsConfigurator={
        firstName: {
            required: 'firstname-required'
        },
        lastName: {
            required: 'lastname-required'
        },
        phone: {
            required: 'phone-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        }
    };

    $form.validationEngine( valOpts );
    $formConfigurator.validationEngine( valOptsConfigurator );
    var rf=$form.data( 'validationEngine' );
    var rfc=$formConfigurator.data( 'validationEngine' );

    $form.on( 'click','.js-submit-button',function( e )
    {
        submitClicked = true;
        var validateBranch = true;
        var validateBrand = true;
        var validateModel = true;

        if ($("#apiCallSuccessful").val() === "success") {
            validateBranch = form.validateBranch();
            validateBrand = form.validateBrand();
            validateModel = form.validateModel();
        }

        valOpts=$form.validationEngine();
        $form.validationEngine( valOpts );
        rf=$form.data( 'validationEngine' );

        e.preventDefault();
        e.stopPropagation();
        var val1=rf.validate();

        if (val1 && validateBranch && validateBrand && validateModel) {
            form.submit();
        } else {
            form.handleErrors();
        }
    });

    $formConfigurator.on( 'click','.js-submit-button',function( e )
    {

        valOptsConfigurator=$formConfigurator.validationEngine();
        $formConfigurator.validationEngine( valOptsConfigurator );
        rfc=$formConfigurator.data( 'validationEngine' );

        e.preventDefault();
        e.stopPropagation();
        var val1=rfc.validate();

        if( val1 )
        {
            formConfigurator.submit();
        } else
        {
            formConfigurator.handleErrors();
        }
    } );

    $form.on( 'keyup','input[name], textarea[name]',function( e )
    {

        if( e.keyCode===13 )
        {
            if( $( this ).prop( "tagName" ).toLowerCase()==="textarea" )
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this=$( this );
        var fieldName=$this.attr( 'name' );

        if( fieldName==="password" )
        {
            form.updatePasswordBar( $this.val() );
        };

        formData[ fieldName ]=$this.val();
        rf=$form.data( 'validationEngine' );
        rf.validate( fieldName );
        form.handleErrors();
    } );

    $formConfigurator.on( 'keyup','input[name], textarea[name]',function( e )
    {

        if( e.keyCode===13 )
        {
            if( $( this ).prop( "tagName" ).toLowerCase()==="textarea" )
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButtonConfigurator.click();

            return;
        };

        var $this=$( this );
        var fieldName=$this.attr( 'name' );

        if( fieldName==="password" )
        {
            formConfigurator.updatePasswordBar( $this.val() );
        }

        formConfiguratorData[ fieldName ]=$this.val();
        rfc=$formConfigurator.data( 'validationEngine' );
        rfc.validate( fieldName );
        formConfigurator.handleErrors();
    } );

    $form.on('click','input[type="checkbox"]', function(e){
        policy = $(this).data('policy');
        if($(this).is(':checked')){
            formData[policy] = true;
        }
        else {
            formData[policy] = false;
        }
    });

    $formConfigurator.on('click','input[type="checkbox"]', function(e){
        policy = $(this).data('policy');
        if($(this).is(':checked')){
            formData[policy] = true;
        }
        else {
            formData[policy] = false;
        }
    });


    $( 'input',$form ).focus(
        function()
        {
            $( this ).parent( 'div' ).addClass( 'focus' );
        } ).blur(
        function()
        {
            $( this ).parent( 'div' ).removeClass( 'focus' );
        } );

    $( 'textarea',$form ).focus(
        function()
        {
            $( this ).parent( 'div' ).addClass( 'focus' );
        } ).blur(
        function()
        {
            $( this ).parent( 'div' ).removeClass( 'focus' );
        } );

    $( 'a[href^="confId"]' ).on( 'click',function( e )
    {
        e.preventDefault();

        var url = $( this ).prop( 'href' ).split('?');
        $.each(url, function (i, el) {
             if (el.split('=')[0] == 'inquiryCode') {
                 inquiryCode = el.split('=')[1];
             }
             if (el.split('=')[0] == 'familyCode') {
                familyCode = parseInt(el.split('=')[1]);
            }
        });

        if( inquiryCode!==''&&inquiryCode!==undefined&&inquiryCode!==null )
        {
            $( '#inquiryCode' ).text( inquiryCode );
            $( '.request-a-quote' ).attr( 'href','#interestFormConfigurator' );
            $( '.request-a-quote' ).click();
        } else
        {
            configurator = new OneDealerVehicleConfigurator();
            var configuratorOptions = new OneDealerConfiguratorOptions();
            //The endpoint of the configurator
            configuratorOptions.Urls.configuratorSourceUrl = configuratorSourceUrl;
            //The endpoint that the configurator will use to get it's dataset (different url per dealer)
            configuratorOptions.Urls.baseUrl = baseUrl;
            //The final URL that will be hit after the configuration ends
            configuratorOptions.Urls.returnUrl = "/IframeRedirect/ActionFinisher";

            configurator.OnVehicleSelected = function ( conf ) {
                $( '#confId' ).remove();
                if (inquiryCode != conf) {
                  inquiryCode = conf;
                  $( '#inquiryCode' ).text( inquiryCode );
                  $( '.request-a-quote' ).attr( 'href', '#interestFormConfigurator' );
                  $( '.request-a-quote' ).click();
                }
            };
            configurator.Init( configuratorOptions );
            configurator.OpenConfigurator( OneDealerConfiguratorType.Light,familyCode );
            $('a[href="#confId"]').fancybox( [ {
                // href: '#confId',
                width: '90%',
                maxWidth: 1200,
                height: '90%',
                fitToView: false,
                autoSize: false,
                helpers: {
                    overlay: {
                        locked: true,
                    }
                },
                btnTpl: {
                    smallBtn: '<a title="Close" data-fancybox-close class="fancybox-item fancybox-close icon-close stylish-fancy-close configurator-close" href="javascript:;"></a>'
                },
                afterClose: function()
                {
                    $( '#confId' ).remove();
                    $( '.site-container' ).removeClass( 'has-filter' );
                },
                afterLoad: function()
                {
                    $( '.site-container' ).addClass( 'has-filter' );
                }
            }] );
        }
    } );

    $( 'a[href^="promo="]' ).on( 'click',function( e ){
        e.preventDefault();

        promoCode=$( this ).prop( 'href' ).split( "=" )[ 1 ];
        if( promoCode!==''&&promoCode!==undefined )
        {
            $( '#inquiryCode' ).text( promoCode );
            $( '.request-a-quote' ).attr( 'href','#interestFormConfigurator' );
            $( '.request-a-quote' ).click();
        }
    } );

    Vendd.MessageBus.subscribe( Vendd.CustomForms.Messages.SendNotificationSuccess,form,form.onSuccess );
    Vendd.MessageBus.subscribe( Vendd.CustomForms.Messages.SendNotificationFailure,form,form.onFailure );


    Vendd.MessageBus.subscribe(Vendd.SubmitToExternalEndpoint.Messages.CreateLeadSuccess, form, function (envelope) {
        var response = envelope.message.data;
        if (response) {
            form.onSuccess();
        } else {
            form.onFailure();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.SubmitToExternalEndpoint.Messages.CreateLeadFailure, form, function (envelope) {
        form.onFailure();
    });
} );